import styles from './ToastProvider.module.scss';
import 'react-toastify/dist/ReactToastify.css';

import { ToastContainer } from 'react-toastify';

export const ToastProvider = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={50000}
      toastClassName={styles.provider}
      hideProgressBar
      closeOnClick
      pauseOnHover
      draggable
      theme="dark"
      toastStyle={{
        background: '#1d1e29',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
      }}
    />
  );
};
